import React, {useState, useRef, useEffect} from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { CountUp } from 'countup.js';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Menu from "../include/menu";
import Section2 from "./section2";
import LiveStates from "./liveStates";
import CoinChart from "./coinChart";
import Test from "./test";
import Footer from "../include/footer";



const IndexSections = () => {
  const logoRef = useRef(null);
  const [logoVisible, setLogoVisible] = useState(false);

  useEffect(() => {
    // Trigger logo appear animation after a short delay
    setTimeout(() => setLogoVisible(true), 300);
  }, []);

  const handleMouseMove = (e) => {
    const logo = logoRef.current;
    const { left, top, width, height } = logo.getBoundingClientRect();

    const x = e.clientX - left - width / 2;
    const y = e.clientY - top - height / 2;

    const rotateX = (-y / 20).toFixed(2);
    const rotateY = (x / 20).toFixed(2);

    logo.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const handleMouseLeave = () => {
    logoRef.current.style.transform = `rotateX(0deg) rotateY(0deg)`;
  };
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // whether animation should happen only once
    });
  }, []);



  return (
  <>
  <div 
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}>
  <Menu />
  <section className="UFOSEC  slideSec ">
    <div className="container">
      <div className="slderIn text-center" >
      <div className={`logo-wrapper op0 ${scrolled ? 'scrolled' : ''}`}  >
        <img
          src="./images/UFO_big_circle.svg"
          className={`img-fluid sliderLogo logoS`}
          ref={logoRef}
          alt="Logo"
        />
      </div>
      <div className={`logo-wrapper logowrapperFixed ${scrolled ? 'scrolled' : ''}`}>
        <img
          src="./images/UFO_big_circle.svg"
          className={`img-fluid sliderLogo logoS`}
          ref={logoRef}
          alt="Logo"
        />
      </div>
        <img src="./images/ufo_logoName.svg"  className="img-fluid logoName"  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1000" />
        <img src="./images/ufo_logoTagline.svg" className="img-fluid logoTagline"  data-aos="fade"  data-aos-delay="400" data-aos-duration="1400"  />
        <Link to="/ufo-onboarding" className="borderbtn mybtn mt-4"  data-aos="fade"  data-aos-delay="500" data-aos-duration="1600"><span>Buy Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></Link>
      </div>
    </div>
  </section>
  <Section2 />
<div className="shapeBg">
  <LiveStates />
  <CoinChart />
</div>
  <section className="boXSecBottom boXSec padsec UFOSEC">
    <div className="container">
      <div className="w-90">
      <div className="row">
        <div className="col-lg-4">
          <div className="snX"  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1000">
            <h4>UFO Pools</h4>
            <p>UFO Token stands as a pivotal amplifier within The Grays ecosystem, strategically engineered to foster unity between the Richard Heart (RH) ecosystem and The Grays Currency. </p>
            
            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <Link to='/ufo-pools' className="someSnbtn d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <img src="./images/ptgc/ufologo_circle.svg" className="img-fluid" style={{width: '39px'}} /></Link>
                </div>
              </div>
            </div>
          </div>
          <div className="snX snX2 bottomSnX"  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="2200">
            <h4>UFO Reward</h4>
            <p>Earn passive income by holding and staking UFO Tokens — get rewarded for supporting the PTGC ecosystem.</p>
            
            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <Link to='/ufo-reward' className="someSnbtn d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className=" snXBig snXBig2"  data-aos="fade"  data-aos-delay="1000" data-aos-duration="1400">
            <div className="snXIn snX mb-0">
              <div>
               <img src="./images/ptgc/ufologo_circle.svg" className="img-fluid" />
               <h4 className="mt-3">How to Buy?</h4>
               <p>Click here to learn how to buy UFO step-by-step using exchanges, wallets, or UFO platforms.</p>
               <div className="someBtnsmod100 someBtns SRTOP ">
                 <Link className="w-100 someSnbtn d-flex justify-content-between align-items-center mt-4" to="/ufo-onboarding"><span>View Now</span> <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" style={{width:'39px', margin: 'initial'}} /></Link>
               </div>
             </div>
            </div>

               
          </div>
        </div>
        <div className="col-lg-4">
          <div className="snX snX3"  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1800">
            <h4>Statistics</h4>
            <p>Access real-time data on token performance, holders, and network activity.</p>
            
            <div className="posbottombtn p-0 b-0">

            <img src="./images/chartStats.svg" className="img-fluid mb" />
            </div>

            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <Link to='/ufo-statistics' className="someSnbtn d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <img src="./images/ptgc/ufologo_circle.svg" className="img-fluid" style={{width: '39px'}} /></Link>
                </div>
              </div>
            </div>
          </div>
          <div className="snX snX4 bottomSnX"  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="2600">
            <h4>UFO Gear</h4>
            <p className="mb-1">Shop hassle-free on UFO Gear—discover the latest products, enjoy secure payments, and experience fast, reliable delivery right to your doorstep!</p>
            
            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <Link to className="someSnbtn d-flex justify-content-between align-items-center mt-0"><span>View Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </section>



  <div className="container-fluid padsec pt-0 px-5">
  <section className="SomeDes  UFOSEC">
    <h1 className="value">The Grays have been watching and waiting to unleash the ultimate cryptocurrency</h1>
  </section>
</div>
  <Footer />
</div>
  </>
  );
};

export default IndexSections;